export default __webpack_public_path__ + "static/media/misc-books3-1920w.2c021dec.png";